module.exports = __webpack_public_path__ + "img/cloudy@2x.89117887.png";